import React, { useContext } from 'react';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useCurrentUser } from '../../../../utils/hooks/useCurrentUser';
import { ResourceType } from '../../../../types/resource';
import AuthorWatchButton from '../../../../Button/AuthorWatchButton';
import DeviationSidebarMosaic from '../../../_partials/DeviationSidebarMosaic';
import DeviationSidebarGrid from '../../../_partials/DeviationSidebarGrid';
import UserLink from '../../../../User/Link/UserLink';
import s from './UserBlock.scss';
const UserBlock = ({ user, deviations, parentDeviation, linkTo })=>{
    const isMobile = useContext(MobileContext);
    const currentUser = useCurrentUser();
    return /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: {
            sectionid: user.userId,
            section_typeid: ResourceType.USER
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['user-header']
    }, /*#__PURE__*/ React.createElement(UserLink, {
        className: s['user-link'],
        user: user,
        linkTo: linkTo
    }), !isMobile && user.userId !== currentUser.userId && /*#__PURE__*/ React.createElement(AuthorWatchButton, {
        className: s['watch-button'],
        author: user
    })), isMobile ? /*#__PURE__*/ React.createElement(DeviationSidebarMosaic, {
        streamId: `devpage-sidebar-users-${parentDeviation.deviationId}-${user.userId}`,
        className: s['user-grid'],
        parentDeviation: parentDeviation,
        deviations: deviations
    }) : /*#__PURE__*/ React.createElement(DeviationSidebarGrid, {
        streamId: `devpage-sidebar-users-${parentDeviation.deviationId}-${user.userId}`,
        className: s['user-grid'],
        parentDeviation: parentDeviation,
        deviations: deviations,
        maxRows: 1
    })));
};
UserBlock.displayName = 'UserBlock';
export default UserBlock;
